
export const PESharedQuickEditState = {
  slider: false,
  partyId: null,
  currentSectionRoute: null,
}

export const PESharedQuickEditActions = {
  peSharedQESliderSetStatus: ({ commit }, payload) => {
    commit('peSharedQESliderSetStatus', payload)
  },
  peSharedQESliderOpen: ({ commit }, partyId) => {
    commit('peSharedQESliderSetpartyId', partyId)
    commit('peSharedQESliderSetStatus', true)
  },
  peSharedQESliderUpdateSectionRoute: ({ commit }, payload) => {
    commit('peSharedQESliderSetcurrentSectionRoute', payload)
  },
}

export const PESharedQuickEditGetters = {
  peSharedQESliderStatus: state => state.partyEdit.quickEdit.slider,
  peSharedQESliderPartyId: state => String(state.partyEdit.quickEdit.partyId),
  peSharedQESliderCurrentSectionRoute: state => state.partyEdit.quickEdit.currentSectionRoute,
}

export const PESharedQuickEditMutations = {
  peSharedQESliderSetStatus: (state, payload) => { state.partyEdit.quickEdit.slider = payload },
  peSharedQESliderSetpartyId: (state, payload) => { state.partyEdit.quickEdit.partyId = payload },
  peSharedQESliderSetcurrentSectionRoute: (state, payload) => {
    state.partyEdit.quickEdit.currentSectionRoute = payload
  },
}
